import { withRouter } from '@om1/platform-routing'
import { connectRedux } from '@om1/platform-utils'
import { CreateCohortWizardDialogComponent } from './CreateCohortWizardDialogComponent'

export function createCreateCohortWizardDialogComponent<TState extends {}>() {
    return connectRedux(withRouter(CreateCohortWizardDialogComponent, { namespace: 'cohort-wizard' }), (state: TState) => ({}), {})
}

export type CreateCohortWizardDialog = ReturnType<typeof createCreateCohortWizardDialogComponent>
